import { render, staticRenderFns } from "./card-multi-boxer.vue?vue&type=template&id=37f75c03&scoped=true&"
import script from "./card-multi-boxer.vue?vue&type=script&lang=js&"
export * from "./card-multi-boxer.vue?vue&type=script&lang=js&"
import style0 from "./card-multi-boxer.vue?vue&type=style&index=0&id=37f75c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f75c03",
  null
  
)

export default component.exports